import type { ReactNode } from 'react';

interface EmptyStateProps { icon?: ReactNode; title: string; description?: string; action?: ReactNode }

export default function EmptyState({ icon, title, description, action }: EmptyStateProps) {
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', padding: '48px 16px', textAlign: 'center' }}>
      {icon && <div style={{ fontSize: '36px', color: 'var(--slate-2)', marginBottom: '12px' }}>{icon}</div>}
      <h3 style={{ fontSize: '16px', fontWeight: 700, color: 'var(--navy)', fontFamily: "'Plus Jakarta Sans', sans-serif" }}>{title}</h3>
      {description && <p style={{ marginTop: '6px', fontSize: '13px', color: 'var(--slate)', maxWidth: '360px' }}>{description}</p>}
      {action && <div style={{ marginTop: '16px' }}>{action}</div>}
    </div>
  );
}
